"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ultravioletPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var ultravioletPalette = {
  ultraviolet10: '#E3E7F6',
  ultraviolet30: '#CBD3F2',
  ultraviolet60: '#9EAEE9',
  ultraviolet: '#677CC8',
  ultravioletDark: '#405AB8',
  ultravioletDarkest: '#0E2579'
};
exports.ultravioletPalette = ultravioletPalette;